var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.$style.wrapp, ( _obj = {}, _obj[_vm.$style.wrapp__open] = _vm.isOpen, _obj )],attrs:{"aria-label":_vm.btnLabel},on:{"click":function($event){return _vm.$emit('set-mode', _vm.isOpen ? '' : 'MENU')},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('set-mode', _vm.isOpen ? '' : 'MENU')}}},[_c('div',{class:[
      _vm.$style.hamburger,
      _vm.$style['hamburger--squeeze'],
      ( _obj$1 = {}, _obj$1[_vm.$style['is-active']] = _vm.isOpen, _obj$1 )
    ]},[_c('span',{class:_vm.$style['hamburger-box']},[_c('span',{class:_vm.$style['hamburger-inner']})])])])}
var staticRenderFns = []

export { render, staticRenderFns }